/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Flow_InvalidInputs */

const en_task_flow_invalid = /** @type {(inputs: Task_Flow_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check the resolutions, checklist and next activities.`)
};

const pt_br2_task_flow_invalid = /** @type {(inputs: Task_Flow_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifique as resoluções, o checklist e as próximas atividades.`)
};

/**
* | output |
* | --- |
* | "Check the resolutions, checklist and next activities." |
*
* @param {Task_Flow_InvalidInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_flow_invalid = /** @type {((inputs?: Task_Flow_InvalidInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Flow_InvalidInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_flow_invalid(inputs)
	return pt_br2_task_flow_invalid(inputs)
});